import Settings from "pages/Settings";
import Home from "pages/Home";
import Research from "pages/Research";
import ProtectedRoute from "ProtectedRoute";
import AppProviders from "providers/AppProviders";
import React from "react";
import { Route, Routes } from "react-router";
import Dashboard from "pages/Dashboard";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-tooltip/dist/react-tooltip.css";
import "swiper/css";
import "swiper/css/pagination";
import Organizer from "pages/Organizer/Organizer";
import Map from "pages/Map";
import PropertyDetails from "pages/PropertyDetails";
import TrialWelcomeDialog from "components/Dialog/TrialWelcomeDialog";
import TrialExpiredDialog from "components/Dialog/TrailExpiredDialog";

const App = () => {
  return (
    <AppProviders>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/research/*" element={<Research />} />
        <Route path="/property/:id" element={<PropertyDetails />} />
        <Route path="/organizer" element={<Organizer />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route path="/map" element={<Map />} />
      </Routes>
      <ToastContainer />
      <TrialWelcomeDialog />
      <TrialExpiredDialog />
    </AppProviders>
  );
};

export default App;
